import { useEffect, useState } from "react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { getReviews } from "../lib/api";
import { Star, Quote } from "lucide-react";

export default function Reviews() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    getReviews().then(setReviews).catch(() => {});
  }, []);

  return (
    <div data-testid="reviews-page">
      <PageHero
        eyebrow="Kind Words"
        title={["Loved by", "families worldwide."]}
        subtitle="Real stories from the families who welcomed one of our teacup puppies into their homes."
      />
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((r, i) => (
            <Reveal key={r.id} delay={(i % 3) * 0.08}>
              <div data-testid={`review-card-${r.id}`} className="h-full bg-white border border-[#E2D1C3] rounded-md p-8 flex flex-col">
                <Quote size={28} className="text-[#E6C5C0] mb-5" />
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: r.rating }).map((_, s) => (
                    <Star key={s} size={15} className="fill-[#C8A98E] text-[#C8A98E]" />
                  ))}
                </div>
                <p className="text-[#3d3226] font-light leading-relaxed flex-1">&ldquo;{r.text}&rdquo;</p>
                <div className="flex items-center gap-4 mt-7 pt-6 border-t border-[#E2D1C3]">
                  <img src={r.avatar} alt={r.name} className="h-12 w-12 rounded-full object-cover" />
                  <div>
                    <p className="font-heading text-lg text-[#2A2118] leading-tight">{r.name}</p>
                    <p className="text-xs text-[#8a7a68]">{r.location} &middot; Adopted {r.puppy_name}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
